import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull/components/OverlayContext/OverlayContext';
import { BulkCreateResultsModal } from '../../../../BulkCreateResultsModal/BulkCreateResultsModal';
import { useTasksDrawer, useTasksDrawerStoreApi } from '../../../../tasksDrawerStore';
const runResultsPropsOf = (task, onReviewDrafts, onSendStarted)=>({
        runId: task.jobId,
        jobName: task.jobName,
        runCancelled: task.status === 'cancelled',
        onReviewDrafts,
        onSendStarted
    });
const resultsOf = (props)=>function RunResults(param) {
        let { dismissModal } = param;
        return /*#__PURE__*/ _jsx(BulkCreateResultsModal, _object_spread_props(_object_spread({}, props), {
            onClose: ()=>dismissModal(undefined)
        }));
    };
export const useOpenCreateRunResults = (task)=>{
    const { showModal } = useOverlayContext();
    const { closeDrawer } = useTasksDrawer();
    const drawerStore = useTasksDrawerStoreApi();
    const registerSendForFeedback = (batchId)=>drawerStore.getState().registerFeedbackPrompt(batchId, {
            feature: 'bulkCreateProposals',
            contextId: batchId
        });
    const content = resultsOf(runResultsPropsOf(task, closeDrawer, registerSendForFeedback));
    return (event)=>{
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        void showModal({
            biName: 'bulk_create_results',
            content
        });
    };
};
